import { azureBlobFSLinkedServiceValidators } from 'shell-models-lib';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

azureBlobFSLinkedServiceValidators.validateAKVLinkedserviceReference = validateAKVLinkedserviceReference;
export { AzureBlobFSLinkedService } from 'shell-models-lib';
